import { render } from "./Step5.vue?vue&type=template&id=9db2b1fe"
import script from "./Step5.vue?vue&type=script&lang=ts"
export * from "./Step5.vue?vue&type=script&lang=ts"
script.render = render

export default script